<template>
    <transition name="pop">
        
        <div class="container" v-if="showme && $root.language == 'fr'">
            <iframe ref="Iframe" src="/packages/handicap/story.html"></iframe>
        </div>
    </transition>
</template>
<script>
import { useLearnStore } from '@/stores/learn'
import { kcAuthStore } from '@/stores/kcAuth'

export default {
    name: "HandicapTile",
    components: {
    },
    watch: {
        currentSound(newVal) {
            if (newVal != '')
                setTimeout(function() {
                    if (window.$(".currentsound").get(0)) window.$(".currentsound").get(0).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                }, 10)

            //
        },
        lng: function(newVal) {
            if (newVal !== 'fr' && newVal !== 'es') {
                this.$root.$router.push("/"+this.$root.language+"/"+newVal);
            } else {
                this.$root.language = this.lng
            }
        },
    },
    mounted() {



        if (this.lng !== 'fr' && this.lng !== 'es') {
            this.$root.$router.push("/"+this.$root.language+"/"+this.lng);
        } else {
            this.$root.language = this.lng
        }
        
    },
    /*props: {
        fullscreen: {
            type: Boolean,
            default: false
        },
        lng:{default:'fr'}
    },*/
    props: ['lng', 'fullscreen'],
    data() {
        return {
            dataslearn: useLearnStore(),
            auth: kcAuthStore(),
            showme: true,
            isplaysound: false,
            sounds_cue: Audio,
            currentSound: '',
            firststeps : undefined,
            firststeps_es:[],
            firststeps_fr: [],
        }
    },
    methods: {
        scrollto: function(e) {
            setTimeout(function() {
                e.el.scrollIntoView({ behavior: "smooth" });
            }, 100)
        },
    },
    created() {
        let that = this;
        this.$root.showNav = true;
        this.$root.showMenu = false;

        that.$root.addPageVisit('handicap');
        
    }
}
</script>
<style scoped>
iframe {
    width: 100%;
    height: 100%;
    border: none;
}



.container {
    position: fixed;
    width: calc(100% - 18em);
    height: calc(100% - 5em);
    border-radius: 1em;
    overflow: hidden;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.18);
}

.fullscreen .container {
   width: calc(100% - 4em);
}

.mobile .container {
    width: 100%;
    height: 100%;
    border-radius: 0;
}


.pop-enter-active,
.pop-leave-active {
    transition: all 350ms;
}

.pop-enter-from {
    opacity: 0;
    scale: .9;
}

.pop-enter-to {
    opacity: 1;
    scale: 1;
}

.pop-leave-from {
    display: none;
    opacity: 1;
    scale: 1;
}

.pop-leave-to {
    display: none;
    opacity: 0;
    scale: .9;
}
</style>